import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { EjercicioSelect } from "../../helpers/EjercicioSelected";
import PeriodoSelected from "../../helpers/PeriodoSelected";
import LineaSelected from "../../helpers/LineaSelected";

export const FiltradoOperacionesCredito = ({
  onExecute,
  msgTitulo,
  setFiltro,
  filtro,
  abrirmodal = false,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    ejercicio: filtro.ejercicio,
    periodo: filtro.periodo,
    linea: filtro.linea,
  });
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    console.log(container, 'asaassa');
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onCargar = () => {
    if (
      state.ejercicio === undefined ||
      state.ejercicio === null ||
      state.ejercicio === ""
    ) {
      Swal.fire(
        "RESUMEN DE OPERACIONES DE VENTA",
        "Favor de seleccionar el ejercicio",
        "warning"
      );
      return;
    }
    setFiltro({
      ...filtro,
      ejercicio: state.ejercicio,
      periodo: state.periodo,
      linea: state.linea,
    });
    onExecute(state.ejercicio, state.periodo,state.linea)
      .then((result) => {
        onOpenModal();
      })
      .catch((error) => {
        Swal.fire(
          "RESUMEN DE OPERACIONES DE VENTA error",
          JSON.stringify(error),
          "error"
        );
      });
  };
  useEffect(() => {
    if (abrirmodal === true) {
      onOpenModal();
    }
  }, []);

  useEffect(() => {
    const filtroGuardado = localStorage.getItem('filtrocargado');
    if (filtroGuardado) {
      
      setFiltro(JSON.parse(filtroGuardado));
      
      const { ejercicio, periodo, linea } = JSON.parse(filtroGuardado);
      state.ejercicio = ejercicio;
      state.periodo = periodo;
      state.linea = linea;
      onOpenModal();
    }
  }, []);


  return (
    <div className="plantilla-sreen-filtro">
      <div
        className="plantilla-sreen-filtro-button-modal"
        onClick={onOpenModal}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="plantilla-sreen-filtro-container" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"plantilla-sreen-filtro-container-modal"}
        >
          <div className="plantilla-sreen-filtro-container-modal-container">
            <EjercicioSelect
              start_year={2024}
              value={state.ejercicio}
              onChange={(ejercicio) => setState({ ...state, ejercicio })}
            />
            <PeriodoSelected
              value={state.periodo}
              onChange={(periodo) => setState({ ...state, periodo })}
              className="plantilla-sreen-filtro-container-modal-container-periodo"
            />
            <LineaSelected
              value={state.linea}
              onChange={(linea) => setState({ ...state, linea })}
              className="plantilla-sreen-filtro-container-modal-container-periodo"
            />
            <div className="plantilla-sreen-filtro-container-modal-modal-acciones">
              <div
                className="plantilla-sreen-filtro-container-modal-modal-acciones-cancelar"
                onClick={onOpenModal}
              >
                Cancelar
              </div>
              <div
                className="plantilla-sreen-filtro-container-modal-modal-acciones-guardar"
                onClick={onCargar}
              >
                Cargar
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
